import AssociatedProgramStatus from "shared/enums/AssociateProgramStatus";
import BaseProgram from "./base";
import { StateStatus } from "shared/enums/StateStatus";

export default class AssociatedProgram extends BaseProgram {
  canManageMeetingCap(): boolean {
    throw new Error("Method not implemented.");
  }
  canViewMeetingPurchases(): boolean {
    throw new Error("Method not implemented.");
  }
  canRemoveOrgFromProgram(): boolean {
    throw new Error("Method not implemented.");
  }
  canShowNoShowFilter(): boolean {
    return false;
  }
  canAdminMarkAsNoShow(): boolean {
    return false;
  }
  canShowAdditionalMeetingMatching(): boolean {
    return false;
  }
  canAddSponsorship(): boolean {
    return false;
  }
  canSendNotification(): boolean {
    return this.checkProgramState(AssociatedProgramStatus.CONFIGURATION, StateStatus.ELAPSED);
  }
}
